import * as userResource from 'resources/user/hooks';
import * as listedKitResource from 'resources/listedkit/hooks';
import * as userHelpers from 'resources/user/user.helpers';
import * as dealHelpers from 'resources/deal/deal.helpers';
import { DEAL_STATUSES, DEAL_TYPES, DEAL_STAGES } from '../deal.constants';
import { LISTEDKIT_TYPES } from 'resources/listedkit/listedkit.constants';

const useDealRestrictions = (deal) => {
  const { data: user } = userResource.useCurrentUser();

  const { isCorporateRealtor } = userResource.useCurrentUserPermissions();
  const isClient = userHelpers.isClient(user);
  const isCoordinatorOrAdmin = userHelpers.isCoordinatorOrAdmin(user);
  const dealStage = dealHelpers.getDealStage(deal);
  const hasFinishedDeal = dealHelpers.isFinished(deal);
  const { data: listedKits } = listedKitResource.useListedKitsByDealId(deal?.id, { enabled: !!deal?.id });

  return {
    isActionsVisible: !isClient,
    isSendDocumentsAvailable: !isClient,
    isEditDisabled: !user || isClient,
    isAuditBadgeVisible: !hasFinishedDeal && (isCoordinatorOrAdmin || isCorporateRealtor),
    isAuditCheckpointVisible: isCoordinatorOrAdmin || isCorporateRealtor,
    isNoteVisible: !isClient,
    isAdvancedValuesVisible: !isClient,
    isCompleteTransactionVisible: dealHelpers.hasStartedTransaction(deal),
    isMoveToUnderContractVisible: dealHelpers.hasNotStartedTransaction(deal),
    isMoveToMakeOfferVisible: dealHelpers.isBuyerHomeSearchDeal(deal),
    isMoveToActiveListing: deal?.type === DEAL_TYPES.SELLER && deal?.status === DEAL_STATUSES.PRE_LISTING,

    // available only for Selling Under Contract that was previously in Active Listing (what means it has a related Pre-Contract kit)
    isRevertToActiveListingVisible:
      deal?.type === DEAL_TYPES.SELLER &&
      dealStage === DEAL_STAGES.UNDER_CONTRACT &&
      listedKits?.some((kit) => kit.type === LISTEDKIT_TYPES.SELLER_PRE_CONTRACT),
  };
};

export default useDealRestrictions;
